import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { BsFillEyeFill } from 'react-icons/bs';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Toggle from 'react-toggle';
import { getCarBrand, getCountries ,UpdateCarBrand , DeleteCarBrand , getCarModel} from '../../../actions/homeAction';
import Modal from '../../../common/Modal';
import Swal from 'sweetalert2';

const CarModel = () => {
	
	const dispatch = useDispatch()
	const [brandId, setBrandId] = useState('')

	useEffect(() => {
		dispatch(getCarBrand())
		dispatch(getCarModel())
		dispatch(getCountries())
	},[])

	const carBrand = useSelector(state => state.home.CarBrandList)
	const carModelLists = useSelector(state => state.home.carModelList)?.response
	const countries = useSelector(state => state.home.countriesList)

	const country = countries?.response

	const viewCarsHandler = (id) => {
		console.log("sadadads", id);
		setBrandId(id)
		
	}
	const handleStatusChange = (Id,status)=>{
		var data ={
			brandId: Id,
			status : !status
		}
		dispatch(UpdateCarBrand(data))
	}
	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarBrand(ID))
		}
	}

  const carModelList = []
  let columns = [];
	columns = [
		{
			name: 'name',
			label: 'Car Brand Name',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'nameAr',
			label: 'Car Brand Name Ar',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'media',
			label: 'Logo ',
			options: {
				filter: false,
				customBodyRender: (media) => {
					// console.log("adasdasdasd", media);
					return <img style={{width:'4rem', height:'4rem', borderRadius:'10px'}} src={media?.path} />
				},
			},
		},
		{
			name: 'country',
			label: 'Country ',
			options: {
				filter: false,
				customBodyRender: (country) => {
					return (
						<span>{country}</span>
					)
				},
			},
		},
		{
			name: 'priority',
			label: 'Priority ',
			options: {
				filter: false,
				customBodyRender: (priority) => {
					return <span>{priority}</span>;
				},
			},
		},
		{
			name: 'brandId',
			label: 'Cars ',
			options: {
				filter: false,
				customBodyRender: (brandId) => {
					return <button type="button" className="btn btn-info" onClick={() => viewCarsHandler(brandId)} data-toggle="modal" data-target="#exampleModalCenter">View</button>
				},
			},
		},
		{
			name: 'brandId',
			label: 'Car Models ',
			options: {
				filter: false,
				sort: true,
				customBodyRender: (brandId) => {
					return (
						<div>
							<Link to={`/CarDetail/CarBrand/CarModel/${brandId}?`}><BsFillEyeFill style={{fontSize: '1.4rem'}} /></Link>
						</div>
					);
				},
			},
			
		},

		{
			name: 'status',
			label: 'Status',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (status, tableMeta) => {
					var Id = tableMeta.rowData[4];
					// console.log(tableMeta.rowData[6]);
					return (
						<Toggle
							id={'status_' + Id}
							checked={status}
							value={status}
							onChange={()=>handleStatusChange(Id, status)}
						/>
					);
				},
			},
		},
		{
			name: 'brandId',
			label: 'Action',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (brandId) => {
					return (
						<div>
							<Link to={`/CarDetail/CarBrand/Update/${brandId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
							<span className='delBTN' onClick={()=>HandleDelete(brandId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
						</div>
					);
				},
			},
		},

	];

	const options = {
		filter: false,
		viewColumns: false,
		print: false,
		download: false,
		selectableRows: 'none',
		textLabels: {
			body: {
				// noMatch: this.state.isSaving
				// 	? 'Loading data..!'
				// 	: 'Sorry, No Users Found',
				toolTip: 'Sort',
				columnHeaderTooltip: column => `Sort for ${column.label}`,
			},
		},
	};

	// console.log("carBranda", countries?.response);

  return (
    <div className='pcoded-inner-content'>
		
		<Modal ID={brandId}/>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/CarBrand/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Car Brand
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Car Brand`}
													className='table-responsive'
													data={carBrand?.response}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel